import React from 'react';
import { useSelector } from 'react-redux';
import ChecklistItem from '@components/cart/ChecklistItem';
import { selectCartItems } from '@features/selectors/selectCartItems';
import { isEmpty } from 'lodash';

import styles from './WithYourPurchase.module.scss';

const WithYourPurchase = ({ minicart = false }) => {
	const splitItems = useSelector(selectCartItems);

	return (
		<div className={`grey-container ${minicart ? styles.miniCartContainer : styles.container}`}>
			<h2 className='title h2'>With your purchase:</h2>
			{!isEmpty(splitItems.bases) && (
				<div id='baseFramePurchase'>
					<ChecklistItem caption='Includes frame case and lens cloth' />
				</div>
			)}
			<ChecklistItem caption='Free standard shipping and free returns' />
			<ChecklistItem caption='30 day risk free trial' />
			<ChecklistItem
				caption='FSA & HSA eligible or insurance reimbursement'
				tooltipMessage='All refunds will be issued to the original payment method — no exceptions.'
			/>
		</div>
	);
};

export default WithYourPurchase;
